// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Wxm1","type":"styles_type__3ouL3","choices":"styles_choices__xoOL7"};